import React from "react";
import { profile } from "../../data/profile";
import { nodeId } from "../../data/connections";
import EvidenceImage from "../../components/investigation/EvidenceImage";
import EvidenceCard from "../../components/investigation/EvidenceCard";
import StickyNote from "../../components/investigation/StickyNote";
import CaseStamp from "../../components/investigation/CaseStamp";
import BoardLegend from "../../components/investigation/BoardLegend";
import { useFlyToSection } from "../../components/investigation/BoardGeometry";
import { detailFromSubjectDossier } from "../../utils/evidenceDetail";

const [givenNames, familyNames] = profile.nameLines;
const quickLinks = ["email", "github", "linkedin"].map((id) => profile.socials.find((link) => link.id === id));

export const HeroSection = () => {
  const flyToSection = useFlyToSection();

  return (
    <div className="hero-cluster">
      <div className="hero-side">
        <EvidenceImage
          src={profile.photo}
          alt={`Portrait of ${profile.displayName}`}
          variant="portrait"
          pin="red"
          rotate={-2}
          label={profile.photoLabel}
          caption={profile.subjectId}
          className="hero-portrait"
        />
        <StickyNote color="yellow" rotate={-3} className="hero-note">
          <p className="hand">start here</p>
          <p>then follow the strings.</p>
        </StickyNote>
      </div>

      <EvidenceCard
        variant="dossier"
        pin="brass"
        rotate={0.4}
        className="hero-casefile"
        nodeId={nodeId.subject}
        detail={detailFromSubjectDossier()}
      >
        <p className="case-kicker">
          {profile.caseNumber} <span aria-hidden="true">·</span> {profile.subjectId}
        </p>
        <h1 className="case-name">
          {givenNames}
          <span>{familyNames}</span>
        </h1>
        <p className="case-title">{profile.title}</p>
        <p className="case-aka">
          <span className="case-aka-label">a.k.a.</span> {profile.aliases.join(" · ")}
        </p>
        <CaseStamp tone="red" rotate={7} className="hero-stamp">
          <span className="live-dot" /> {profile.status}
        </CaseStamp>

        <p className="case-summary">{profile.summary}</p>

        <dl className="case-stats">
          {profile.stats.map((stat) => (
            <div key={stat.label}>
              <dd>{stat.value}</dd>
              <dt>{stat.label}</dt>
            </div>
          ))}
        </dl>

        <p className="case-base">
          <span>Base of operations</span> {profile.location}
        </p>

        <div className="case-actions">
          <button type="button" className="case-action case-action--primary" onClick={() => flyToSection("projects")}>
            See the evidence ↓
          </button>
          {quickLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="case-action"
              target={link.id === "email" ? undefined : "_blank"}
              rel={link.id === "email" ? undefined : "noreferrer"}
            >
              {link.label} ↗
            </a>
          ))}
        </div>
      </EvidenceCard>

      <BoardLegend className="hero-legend" />
    </div>
  );
};

export default HeroSection;
